var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 25.4222V11.7778H27.1109L28.8664 10H8.88867V25.4222H10.6665Z",
    fill: "#4B00CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66656 7.77778H33.3332V25.5556H35.5554V7.22222C35.5554 6.78019 35.3799 6.35627 35.0673 6.04371C34.7547 5.73115 34.3308 5.55556 33.8888 5.55556H6.111C5.66897 5.55556 5.24505 5.73115 4.93249 6.04371C4.61993 6.35627 4.44434 6.78019 4.44434 7.22222V25.5556H6.66656V7.77778Z",
    fill: "#4B00CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11133 27.7778V31.5556C1.11133 32.3217 1.41569 33.0565 1.95746 33.5983C2.49924 34.1401 3.23404 34.4444 4.00022 34.4444H35.9335C36.6997 34.4444 37.4345 34.1401 37.9763 33.5983C38.5181 33.0565 38.8224 32.3217 38.8224 31.5556V27.7778H1.11133ZM36.6669 31.5556C36.6669 31.7324 36.5966 31.9019 36.4716 32.027C36.3466 32.152 36.177 32.2222 36.0002 32.2222H3.95577C3.77896 32.2222 3.60939 32.152 3.48437 32.027C3.35934 31.9019 3.28911 31.7324 3.28911 31.5556V29.4778H14.3447C14.4836 29.8055 14.7154 30.0854 15.0116 30.2829C15.3078 30.4803 15.6554 30.5867 16.0113 30.5889H23.9335C24.2895 30.5867 24.6371 30.4803 24.9332 30.2829C25.2294 30.0854 25.4613 29.8055 25.6002 29.4778H36.6669V31.5556Z",
    fill: "#4B00CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.51e3a246aa3e26e7cbdb768be40d37f6.svg";
export { ForwardRef as ReactComponent };